import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMailIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 48,
	viewBox: "0 0 48 48",
	width: 48,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m6048.166 950.566a24 24 0 1 0 24 24 24 24 0 0 0 -24-24zm13.333 12.745a2.663 2.663 0 0 1 1.1.242l-12.032 12.033a3.476 3.476 0 0 1 -4.8 0l-12.033-12.033a2.663 2.663 0 0 1 1.1-.242zm2.679 19.832a2.678 2.678 0 0 1 -2.679 2.678h-26.667a2.678 2.678 0 0 1 -2.678-2.678v-17.154a2.659 2.659 0 0 1 .242-1.1l12.032 12.033a5.284 5.284 0 0 0 7.474 0l12.034-12.033a2.682 2.682 0 0 1 .241 1.1z",
		fill: "#fff",
		transform: "translate(-6024.167 -950.566)"
	})
});
export default SvgMailIcon;
